import './i18n';
import './assets/scss/theme.scss';
import './assets/scss/user.scss';
import React from 'react';

import AppProvider from './providers/AppProvider';
import { createRoot } from 'react-dom/client';
import BreakpointsProvider from './providers/BreakpointsProvider';
import SettingsPanelProvider from './providers/SettingsPanelProvider';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './shared/stored/store';
import AppRoute from './components/app-route';
import routes from './routes';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppProvider>
          <SettingsPanelProvider>
            <BreakpointsProvider>
              <AppRoute routes={routes} />
            </BreakpointsProvider>
          </SettingsPanelProvider>
        </AppProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
